import { Controller } from "@hotwired/stimulus"

// Marks the item (menu link) whose section is currently being read with
// aria-current="true". A section counts as current while it overlaps the
// reading band: from just below the sticky menu down to 30% of the viewport.
export default class extends Controller {
  static targets = ["section", "item"]

  connect() {
    this.observe()
    this.onResize = () => this.observe()
    window.addEventListener("resize", this.onResize)
  }

  disconnect() {
    this.observer?.disconnect()
    window.removeEventListener("resize", this.onResize)
  }

  observe() {
    this.observer?.disconnect()
    this.intersecting = new Set()
    this.observer = new IntersectionObserver(
      entries => this.update(entries),
      { rootMargin: `-${this.menuHeight}px 0px -70% 0px` }
    )
    this.sectionTargets.forEach(section => this.observer.observe(section))
  }

  update(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.intersecting.add(entry.target)
      } else {
        this.intersecting.delete(entry.target)
      }
    })
    const current = this.sectionTargets.find(section =>
      this.intersecting.has(section)
    )
    this.itemTargets.forEach(item => {
      if (current && item.hash === `#${current.id}`) {
        item.setAttribute("aria-current", "true")
      } else {
        item.removeAttribute("aria-current")
      }
    })
  }

  get menuHeight() {
    const height = getComputedStyle(document.documentElement).getPropertyValue(
      "--menu-height"
    )
    return parseInt(height, 10) || 0
  }
}
